import React from 'react';
import { Link as RouterLink, useLocation, useHistory } from 'react-router-dom';
import { List, ListItem, Button, Link } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

import { isCurrentLocation } from 'utils/location';
import { GET_ENUMS } from 'const/router';
import MobileNonAuthHeader from 'sharedComponents/MobileNonAuthHeader';

import { appRoutes, externalRoutes } from 'routes';
import useScreen from 'hooks/useScreen';
import DesktopHeader from './components/DesktopHeader';
import useStyles from './useStyles';

const Header = () => {
  gsap.registerPlugin(ScrollToPlugin);
  const { isDesktop } = useScreen();
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();

  const { pathname } = useLocation();

  const handleClick = () => {
    gsap.to(window, { duration: 1, scrollTo: '#how-it-works' });
  };

  const isLoanOfficerLocation = isCurrentLocation(history, appRoutes.loanOfficerPath());
  const isRealEstateAgentLocation = isCurrentLocation(history, appRoutes.realEstateAgentPath());
  const isMainLocation = !isLoanOfficerLocation && !isRealEstateAgentLocation;

  return isDesktop ? (
    <DesktopHeader>
      <List className={classes.nav}>
        <ListItem className={classes.navItem}>
          <Link className={classes.navLink} component="button" onClick={handleClick}>
            {t('components.NonAuthHomePage.Header.Navigation.howItWorks')}
          </Link>
        </ListItem>
        <ListItem className={classes.navItem}>
          <Link className={classes.navLink} component={RouterLink} to={appRoutes.quizPath()}>
            {t('components.NonAuthHomePage.Header.Navigation.budget')}
          </Link>
        </ListItem>
        <ListItem className={classes.navItem}>
          <Link
            className={classes.navLink}
            component={RouterLink}
            to={{ pathname, search: `?popup=${GET_ENUMS.popup.login}` }}
          >
            {t('components.NonAuthHomePage.Header.Navigation.logIn')}
          </Link>
        </ListItem>
        <ListItem className={classes.navItem}>
          {isMainLocation ? (
            <Button to={appRoutes.surveyPath()} component={RouterLink} className={classes.navButton}>
              {t('components.NonAuthHomePage.Header.Navigation.getStarted')}
            </Button>
          ) : (
            <Button
              href={externalRoutes.requestDemoPath()}
              target="_blank"
              component={Link}
              className={classes.navButton}
            >
              {t('components.NonAuthHomePage.Header.Navigation.scheduleDemo')}
            </Button>
          )}
        </ListItem>
      </List>
    </DesktopHeader>
  ) : (
    <MobileNonAuthHeader isBuyerLocation={isMainLocation} />
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Header/Header.js